
import React from "react";
import { Project } from "@/types";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Folder, Plus } from "lucide-react";
import ProjectCard from "./ProjectCard";

interface ProjectGridProps {
  projects: Project[];
  onProjectSelect: (project: Project) => void;
}

export default function ProjectGrid({ projects, onProjectSelect }: ProjectGridProps) {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
      {projects.map((project) => (
        <ProjectCard 
          key={project.id}
          project={project}
          onSelect={onProjectSelect}
        />
      ))}
      
      {projects.length === 0 && (
        <div className="col-span-1 sm:col-span-2 lg:col-span-3 py-12 sm:py-20 text-center px-4">
          <Folder className="h-8 w-8 sm:h-12 sm:w-12 text-gray-300 mx-auto mb-3 sm:mb-4" />
          <h3 className="text-base sm:text-lg font-medium text-gray-700 mb-1">No projects found</h3>
          <p className="text-sm text-muted-foreground mb-3 sm:mb-4">Try adjusting your search or filters</p>
          <Button onClick={() => navigate("/new-project")} size="sm" className="text-sm">
            <Plus className="mr-2 h-4 w-4" /> New Project
          </Button>
        </div>
      )}
    </div>
  );
}
